import getContactPhone from "./getContactPhone";
const whatReport = (nameAsegurado, lastAsegurado, clave) => {
  const url = `https://wa.me/521${getContactPhone()}?text=${encodeURIComponent(
    `Hola, soy ${nameAsegurado} ${lastAsegurado}, solicité una asistencia y mi número de reporte es: ${clave}`
  )}`;

  return url;
};
export default whatReport;
